import { Button, Card, Col, Input, InputNumber, Row } from "antd";
import React, { useState } from "react";
import { RiAddCircleFill } from "react-icons/ri";
import { CgCloseO } from "react-icons/cg";
import { TbCurrencyDollar } from 'react-icons/tb';

import "./CreditCards.css";

function CreditCards({ data }) {
  const [checked, setChecked] = useState(false);

  const [creditCards, setCreditCards] = useState([
    {
      issuer: "",
      balance: "",
    },
  ]);

  const addAnotherCreditCards = () => {
    setCreditCards([
      ...creditCards,

      {
        issuer: "",
        balance: "",
      },
    ]);
  };

  const onRemoveCreditCards = (index) => {
    const newCreditCards = [...creditCards];
    newCreditCards.splice(index, 1);
    setCreditCards(newCreditCards);
  };
  return (
    <Row className="credit-cards">
      <Col span={24}>
        <Card
          title="Credit Cards"
          extra={
            !checked ? (
              <span className="onclick-text" onClick={() => setChecked(true)}>
                Edit
              </span>
            ) : null
          }
        >
          {checked ? (
            <Row gutter={[0, 8]}>
              <Col span={24}>
                <Row justify="start" gutter={[8, 0]}>
                  <Col className="header-row" span={18}>
                    <span>Issuer</span>
                  </Col>
                  <Col className="header-row" span={5}>
                    <span>Balance</span>
                  </Col>
                </Row>
              </Col>
              {creditCards.map((item, index) => {
                return (
                  <Col span={24} key={index}>
                    <Row gutter={[8, 0]} align="middle">
                      <Col span={18}>
                        <Input placeholder="Issuer" />
                      </Col>
                      <Col span={5}>
                        <InputNumber placeholder="Balance" style={{ width: "100%" }} addonBefore={<TbCurrencyDollar size={16} /> }/>
                      </Col>
                      {creditCards.length > 1 ? (
                        <Col span={1}>
                          <CgCloseO
                            className="delete-btn"
                            size={20}
                            onClick={() => onRemoveCreditCards(index)}
                          />
                        </Col>
                      ) : null}
                    </Row>
                  </Col>
                );
              })}
              <Col span={24}>
                <button
                  onClick={() => addAnotherCreditCards()}
                  className="add-icon-btn"
                >
                  <RiAddCircleFill size={18} />
                  <span>Add Another Credit Card</span>
                </button>
              </Col>
              <Col span={24} className="buttons-container">
                <Row gutter={[8, 0]}>
                  <Col>
                    <Button type="primary">Save</Button>
                  </Col>
                  <Col>
                    <Button onClick={() => setChecked(false)}>Cancel</Button>
                  </Col>
                </Row>
              </Col>
            </Row>
          ) : (
            <Row>
              {data?.length >= 1 ? (
                <Col span={24}>
                  <Row>
                    <Col span={24}>
                      <Row gutter={[8, 0]} className="header-row">
                        <Col span={18}>
                          <span>Issuer</span>
                        </Col>
                        <Col span={6}>
                          <span>Balance</span>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                  {data?.map((item, index) => {
                    return (
                      <Row gutter={[8, 0]} className="data-row" key={index}>
                        <Col span={6}>
                          <span>{item.make}</span>
                        </Col>
                        <Col span={6}>
                          <span>{item.model}</span>
                        </Col>
                      </Row>
                    );
                  })}
                </Col>
              ) : (
                <Col span={24}>
                  <Row justify="center">
                    <Col>
                      <p>
                        Applicant did not provide any credit card information.
                      </p>
                    </Col>
                  </Row>
                </Col>
              )}
            </Row>
          )}
        </Card>
      </Col>
    </Row>
  );
}

export default CreditCards;
